import { render } from "./EditProgramDialog.vue?vue&type=template&id=7465057f&scoped=true"
import script from "./EditProgramDialog.vue?vue&type=script&lang=js"
export * from "./EditProgramDialog.vue?vue&type=script&lang=js"

import "./EditProgramDialog.vue?vue&type=style&index=0&id=7465057f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7465057f"]])

export default __exports__